import { useMutation } from "react-query";
import { postApi } from "../../fetch-api/post";
import { useQueryContext } from "../../../contexts/query";
import { useNavigate } from "react-router-dom";
import { useMainContext } from "../../../contexts/main";
import { deleteApi } from "../../fetch-api/delete";
import { useAclContext } from "../../../contexts/acl";
import { normalFetch } from "../../fetch-api/get";


const AUTH_KEYS = {
    LOGIN: "login",
    LOGOUT: 'logout'
}


export const useLoginMutation = () => {
    const { setToken } = useMainContext()
    const navigate = useNavigate()

    return useMutation(
        AUTH_KEYS.LOGIN, (data) => postApi(data.data, `login`),
        {
            onSuccess: (res) => {
                const accessToken = res.data.data.access_token
                setToken(accessToken)
                navigate('/')
            }
        }
    )
}


export const useLogoutMutation = () => {

    const navigate = useNavigate()
    const { setToken } = useMainContext()
    const { setToast, queryCache } = useQueryContext()
    const { reset } = useAclContext()

    return useMutation(
        AUTH_KEYS.LOGOUT, () => normalFetch('admin/logout'),
        {
            onSuccess: () => {
                setToast({
                    show: true,
                    message: 'logout-success'
                })
                setToken('')
                reset()
                queryCache?.clear()
                navigate('/login')
                setTimeout(() => {
                    window.location.reload()
                }, 2000)
            }
        }
    )
}